"use client";

import JobDetailContent, { type JobData } from "@/components/Company/JobDetailContent";

const jobData: JobData = {
  title: "Backend Developer (PHP)",
  sections: [
    {
      title: "Responsibilities",
      items: [
        "Work with ECQ security team to develop new and cutting edge projects.",
        "Review, modify, or convert existing code/applications to newer platform.",
        "Ensure that all phases of development as described in the development process are completed and that milestones are delivered on time.",
        "Coordinate and work with ECQ team in the US.",
        "Follow Secured Software Development Life-cycle of ECQ to ensure the applications are thoroughly tested and operated in a secured manner.",
      ],
    },
    {
      title: "Skills and Experience",
      items: [
        "Strong knowledge and experience on PHP.",
        "Strong understanding of OOP.",
        "Good database knowledge: MySQL, MSSQL, MongoDB, ...",
        "Experience in Restful API, advanced JavaScript (including prototype-based inheritance, event delegation, closures, AJAX, JSON).",
        "Experience working with system design, database architecture, and middleware development.",
        "Good awareness about security and performance in web development.",
        "Working knowledge in source version control (GIT).",
        "Experience in Scrum, Git is a huge priority.",
        "Be proactive in identifying and solving problems.",
        "Ability to independent work directly with tasks. Strong responsibility.",
        "Be able to communicate in English.",
      ],
    },
    {
      title: "Big Bonus",
      items: [
        "Having knowledge about other website development languages such as JavaScript, HTML, CSS, etc.",
        "Having knowledge about Devops: Docker, AWS, CI/CD.",
        "Knowledge about distributed system architect / microservices.",
        "Comfort working with Linux server, deployment and configuration.",
        "Experience in Caching (Redis/Memcache).",
        "Design Pattern.",
        "GraphQL.",
      ],
    },
  ],
  closingNote:
    "ECQ firmly believes in Skills and Quality of Work. No certification or degree is required. All candidates are welcomed and will be screened through technical interview. All applications will be treated as strictly confidential. Successful candidate will receive attractive remuneration package. Interested applicants please submit your application and resume with a recent photo either by post or e-mail to the following address.",
  applyEmail: "hr@e-cq.net",
};

export default function PHPDeveloperJD() {
  return <JobDetailContent data={jobData} />;
}
